import React from 'react'
import { Query } from 'react-apollo'
import { LoadingPage } from '../../components'
import { VENUE_OPTIONS_QUERY } from '../../gql'
import { WithUser } from '../components'

const WithVenueOptions = props => {
  return (
    <WithUser>
      {({ user }) => (
        <Query
          query={VENUE_OPTIONS_QUERY}
          variables={{ userId: user.id }}
          fetchPolicy={'cache-and-network'}
        >
          {({ data, loading }) => {
            if (loading) return <LoadingPage />
            return props.children(data)
          }}
        </Query>
      )}
    </WithUser>
  )
}

export default WithVenueOptions
